// Sentry's `environment` is a free-form string. We derive it from the hostname
// subdomain (the same signal src/app/settings/base-url.ts uses to pick the API
// URL) so new feature branches are tracked automatically with no list to keep
// in sync: `gryffindor.noomo.org` simply reports environment `gryffindor`.
export function resolveEnvironment(hostname: string): string {
  if (hostname.includes('localhost')) {
    return 'development';
  }

  const subdomain = hostname.split('.')[0];

  if (subdomain === 'prod') {
    return 'production';
  }

  if (subdomain === 'stage') {
    return 'staging';
  }

  // pre-prod, feature branches (gryffindor, rohan, …) and any other host
  // report under their own subdomain.
  return subdomain;
}
